import { useRef, useState } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';

/**
 * 單行文字超過 maxWidth 時以 ... 截斷，實際被截斷才會出現完整內容的 tooltip
 * - 桌機：hover 顯示、移開隱藏
 * - 觸控：點擊顯示、點擊其他處隱藏（rootClose）
 */
function TruncatedText({ text, maxWidth, placement = 'top' }) {
  const targetRef = useRef(null);
  const [show, setShow] = useState(false);

  // 觸發當下量測是否溢出，避免視窗縮放後狀態過期
  const isTruncated = () => {
    const el = targetRef.current;
    return el && el.scrollWidth > el.clientWidth;
  };

  return (
    <>
      <div
        ref={targetRef}
        className="text-truncate"
        style={{ maxWidth }}
        onMouseEnter={() => isTruncated() && setShow(true)}
        onMouseLeave={() => setShow(false)}
        onClick={() => isTruncated() && setShow(true)}
      >
        {text}
      </div>
      <Overlay
        target={targetRef}
        show={show}
        placement={placement}
        rootClose
        onHide={() => setShow(false)}
      >
        {(props) => <Tooltip {...props}>{text}</Tooltip>}
      </Overlay>
    </>
  );
}

export default TruncatedText;
